import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const useSyncRouteWithBrowser = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const syncRouteWithBrowser = () => {
      const browserPath = window.location.pathname;

      if (location.pathname !== browserPath) {
        navigate(browserPath);
      }

      setTimeout(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      }, 0);
    };

    syncRouteWithBrowser();

    window.addEventListener('popstate', syncRouteWithBrowser);

    return () => {
      window.removeEventListener('popstate', syncRouteWithBrowser);
    };
  }, [location, navigate]);
};

export default useSyncRouteWithBrowser;
